export enum EOrderStatus {
    REQUEST_CALLBACK = 'Request Callback',
    ACCEPT = 'Accept',
    REVIEW = 'Review',
    EXPIRED = 'Expired',
    PENDING = 'Pending',
    EXPIRE_SOON = 'Expire Soon',
}

export enum ESchoolType {
    NEW_SCHOOL = 'New School',
    RETENTION_SCHOOL = 'Retention School',
}

export enum ETableColumn {
    SR_NO = 'srNo',
    ORDER_ID = 'orderId',
    PROPOSAL_NAME = 'proposalName',
    SENT_BY = 'sentBy',
    EXPIRE_DATE = 'expireDate',
    PRODUCTS = 'products',
    TOTAL_VALUE = 'totalValue',
    ACTION = 'action',
}

export enum EExpiryStatus {
    SAFE = 'safe',
    WARNING = 'warning',
    EXPIRED = 'expired',
}

export enum ELandingAction {
    AddTeacher = 'add-teacher',
    AddStudent = 'add-student',
}

export enum EAddStudentField {
    FirstName = 'firstName',
    MiddleName = 'middleName',
    LastName = 'lastName',
    Class = 'class',
    Section = 'section',
    DateOfBirth = 'dateOfBirth',
    Gender = 'gender',
    EnrollmentNumber = 'enrollmentNumber',
    RollNo = 'rollNo',
}

export enum EUserGender {
    Female = 'female',
    Male = 'male',
    PreferNotToSay = 'other',
}

export enum EAddTeacherField {
    FirstName = 'firstName',
    MiddleName = 'middleName',
    LastName = 'lastName',
    DateOfBirth = 'dateOfBirth',
    Gender = 'gender',
    Phone = 'phone',
    Email = 'email',
    Title = 'title',
    Designation = 'designation',
}

export enum EAddAdminField {
    FirstName = 'firstName',
    MiddleName = 'middleName',
    LastName = 'lastName',
    Gender = 'gender',
    Phone = 'phone',
    Title = 'title',
    DateOfBirth = 'dateOfBirth',
    Email = 'email',
}

export enum EAddTeacherRole {
    Teacher = 'teacher',
    Admin = 'admin',
    SuperAdmin = 'super-admin',
}

export enum EAddTeacherDesignation {
    Pgt = 'pgt',
    Tgt = 'tgt',
    Prt = 'prt',
    Coordinator = 'coordinator',
}

export enum EAddTeacherTitle {
    MiddleSchoolCoordinator = 'middle_school_coordinator',
    MiddleSchoolTeacher = 'middle_school_teacher',
}

export enum EUserStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DRAFT = 'DRAFT',
    REMOVED = 'REMOVED',
}

export enum EUserChildType {
    STUDENT = 'student',
    TEACHER = 'teacher',
    ADMIN = 'admin',
}

export enum EStudentSearchCategory {
    ROLL_NO = 'rollNo',
    USERNAME = 'username',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    CLASS = 'class',
    SECTION = 'section',
    GENDER = 'gender',
    STATUS = 'status',
}

export enum EPreferenceAttributeId {
    DualLogin = 9,
    LabFacilty = 17,
}
